<template>
  <div class="carousel fade-carousel slide" data-interval="7000" id="bs-carousel" data-ride="carousel">
        <!-- Overlay -->
        <div class="overlay"></div>
            
        <!-- Indicators -->
        <ol class="carousel-indicators">
            <li v-for="map in maps" :key="map.index" data-target="#bs-carousel" v-bind:class="{ 'active' : map.index === 0 }" :data-slide-to="map.index"></li>
        </ol>
        
        <div class="carousel-inner">
            <div class="item slides" v-for="map in maps" :key="map._id" v-bind:class="{ 'active': map.index ===  0}">
                <div class="slide-container" v-bind:class="'slide-' + (map.index + 1)"></div>
                <div class="ol-featured_background" v-bind:style="{ backgroundImage: map.backgroundImage }"></div>
                <div class="hero hero-transition featured">
                    <hgroup>
                        <div class="ol-featured_content-type">Recently Released</div>
                        <h1>{{ map.name }}</h1>
                        <div class="ol-featured_divider"></div> 
                        <div class="ol-featured_sub-header release-date"><i class="fa fa-calendar-o"></i>{{ map.releaseDate | date }}</div>
                        <div class="ol-featured_sub-header release-date"><i class="fa fa-gamepad"></i>{{ map.gameTypes | arrayToString }}</div>
                        <div class="ol-featured_sub-header author"><i class="fa fa-user"></i>{{ map.author }}</div>
                        <div class="ol-featured_divider"></div> 
                        <div class="ol-featured_description">{{ map.review }}</div>
                    </hgroup>
                    <div class="ol-featured_actions">
                        <a class="ol-featured_button" :href="'/review/' + map._id">Read Details</a>
                        <a class="ol-featured_button" :href="'/maps/' + map.filename">Download Now</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { api } from '../framework/api';
import { settings } from '../framework/settings';

export default {
    data() {
        return {
            first: '',
            maps: []
        }
    },
    async created() {
        var i = 0;
        $("#bs-carousel").carousel();
        let results = await api.get('reviews/recent');
        this.maps = results.data.map(m => {
            m.index = i++;
            m.backgroundImage = `url('${settings.siteUrl}/screens/${m.screenshot}')`;
            return m;
        });
        this.first = this.maps[0]._id;
    }
}
</script>


// WEBPACK FOOTER //
// src/components/RecentReleases.vue